module.exports = __webpack_public_path__ + "img/route.b5c8dd6e.svg";